import {LABELS} from './labels'

export const FALLBACK_WIDTH = '256px'

const MAX_CHAR_VALUE_LENGTH: number = 255

export const textValidation = (value: string): string | null => {
  const {length} = value
  if (length > MAX_CHAR_VALUE_LENGTH) {
    return LABELS.textValidationMaxLength(length, MAX_CHAR_VALUE_LENGTH)
  }
  return null
}
